import { initializeApp } from 'firebase/app';
import {
  browserLocalPersistence,
  connectAuthEmulator,
  getAuth,
  inMemoryPersistence,
  setPersistence,
} from 'firebase/auth';

// Firebase web config — mirrors admin-web/src/api/firebase.ts. Backend-mediated login (FEATURE_070):
// the BE returns a Firebase CUSTOM token that we exchange via signInWithCustomToken to get the ID token
// the interceptor then sends as Bearer. For the local Auth emulator the apiKey/authDomain are placeholders
// (the emulator does not validate them); production supplies real values via VITE_FIREBASE_* at build time.
const firebaseApp = initializeApp({
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? 'demo-emulator',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? '',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? 'ards-local',
});

export const auth = getAuth(firebaseApp);

// NFR-SEC: the session token MUST live in memory only — never localStorage / sessionStorage. Firebase's
// default is `local` (IndexedDB); switch to in-memory so a tab close drops the session.
// VITE_FIREBASE_PERSIST=local is a dev-only opt-out (survive a reload) — never the production default.
const persistence =
  import.meta.env.VITE_FIREBASE_PERSIST === 'local' ? browserLocalPersistence : inMemoryPersistence;
void setPersistence(auth, persistence);

// Dev: route all Auth calls to the local emulator (VITE_FIREBASE_AUTH_EMULATOR_URL, e.g.
// http://localhost:9099). MUST stay unset in production → real Firebase.
const emulatorUrl = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_URL;
if (emulatorUrl) {
  connectAuthEmulator(auth, emulatorUrl, { disableWarnings: true });
}
